<template>
  <div class="detail">
    <hight-light :text="info.name" :bg-text="info.name" :english="info.english" :is-bg="true"/>
    <el-button class="back" type="primary" plain @click="back">返回</el-button>
    <div class="content">
      <div class="title">{{ info.title1}}</div>
      <div class="desc-box" v-if="info.id === '101'">
        <img v-if="info.image" :src="info.image" alt="">
        <div class="letter">
          <div class="desc" v-for="(item, index) in info.desc" :key="index">
            {{ item }}
          </div>
          <div class="desc" v-for="item in info.engDesc" :key="item">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="title" v-if="info.imageList.length > 0" style="margin-top: 16px">{{ info.name }}( {{ info.english }} )</div>
      <div class="column-center" v-if="info.imageList.length > 0">
          <span v-for="(item, index) in info.imageList" :key="index">
            <img :src="item" alt="">
          </span>
      </div>
    </div>
  </div>
</template>

<script>
import { projects } from "@/assets/project";
import HightLight from "@/components/common/hightLight/HightLight";
export default {
  name: "ProjectDetail",
  components:{ HightLight, },
  data(){
    return{
      projects,
      id:0,
      name: '',
      image: '',
      english: '',
      info: {}
    }
  },
  mounted (){
    this.init()
  },
  methods: {
    init () {
      this.id = this.$route.query.id
      this.handleDetail()
    },
    handleDetail () {
      projects.map(item => {
        if (item.id === this.id) {
          this.info = item
        }
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.detail{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  .back {
    width: 100px;
    margin-bottom: 16px;
  }
  .content {
    margin: 16px;
    .title {
      padding: 0 0 0 16px;
      border-left: 6px solid #3a8ee6;
      font-size: 22px;
      color: #3a8ee6;
      margin-bottom: 16px;
    }
    .desc-box {
      display: flex;
      img {
        width: 400px;
        height: 350px;
      }
      .letter {
        margin-left: 16px;
        display: flex;
        flex-direction: column;
        flex: 1;
      }
      .desc {
        display:flex;
        white-space: pre-wrap;
        text-indent: 2em;
        line-height: 26px
      }
    }
  }
  .column-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  .advantage-box {
    .advantage-item {
      font-size: 18px;
      .red {
        margin-top: 8px;
        color: #F15454;
      }
      .black {
        margin-top: 8px;
        padding-left: 22px;
        color: #444444;
      }
      .gray {
        margin-top: 8px;
        padding-left: 22px;
        color: rgba(39, 46, 58, 0.8);
      }
    }
  }
}
</style>
